import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TrialDialogData } from '@pyg-services/trial-dialog.service';
import { FreeTrialComponent } from '@pyg-shared/free-trial/free-trial.component';

@Component({
  selector: 'app-demo-form',
  templateUrl: './demo-form.component.html',
  styleUrls: ['./demo-form.component.scss'],
  imports: [FreeTrialComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoFormComponent {
  public readonly trialData: TrialDialogData = {
    title: 'getdemo.title',
    place: 'Get Demo page',
    subtitle: 'getdemo.subtitle',
    isMuseum: false,
  };

  public readonly demoItems = [
    'getdemo.store_revenue',
    'getdemo.pyg_platform',
    'getdemo.matching_critical',
    'getdemo.pricing_details',
  ];
}
